import * as React from 'react';
import { Panel } from '../Panel';
import { ICONS } from '../../../assets/Icons';
import { graphStyle } from '../../../assets/styles/Layout/AreaGraph';
import { PieChart, Pie, Cell } from 'recharts';
import { CurrentValue } from '../CurrentValue';
import { ValueDelta } from '../ValueDelta';
import { CONSTANTS } from '../../../assets/UIConstants';
import { PanelFooter } from '../PanelFooter';
import WaterIcon from '../svgs/WaterIcon';
import {
    TOTAL_BODY_WATER_INFO, TOTAL_BODY_WATER_PANEL_TITLE,
    TOTAL_BODY_WATER_POPOVER_TITLE
} from '../../../assets/ApplicationCopy';
import { AbstractPanel, IDataPoint } from './AbstractPanel';
import { Scan } from '../../../data_layer/models/Scan';
import { FullSummaryCategories } from '../../pages/FullSummary';

const COLORS = [CONSTANTS.COLORS.WHITE, CONSTANTS.COLORS.THEME_BLUE_DISABLED];

export class TotalBodyWater extends AbstractPanel {
    protected panelId: string = FullSummaryCategories.BodyWater;
    protected panelTitle: string = TOTAL_BODY_WATER_PANEL_TITLE;
    protected popoverTitle: string = TOTAL_BODY_WATER_POPOVER_TITLE;
    protected popoverBody: string | JSX.Element = TOTAL_BODY_WATER_INFO;

    protected fullSummaryLinkPath: string = 'total-body-water';
    protected graphUnit: string = '%';

    protected yValueExtractor(scan: Scan): number {
        return (scan.scan_results.totalBodyWaterPounds / scan.scan_results.weightPounds) * 100;
    }

    protected get graphDataPoints(): IDataPoint[] {
        return [];
    }

    private data = [
        {
            name: 'Total Body Water',
            value: this.currentValue
        },
        {
            name: 'Remaining',
            value: 100 - this.currentValue
        }
    ];

    public render(): JSX.Element {
        return (
            <Panel
                id={this.panelId}
                width={500}
                height={410}
                title={this.panelTitle}
                style={panelStyle}
                iconColor={CONSTANTS.COLORS.WHITE}
                iconBorderColor={CONSTANTS.COLORS.WHITE}
                icon={ICONS.QUESTION_MARK}
                popoverTitle={this.popoverTitle}
                popoverBody={this.popoverBody}
            >
                <div style={graphStyle.container}>
                    <div style={panelContentStyle}>
                        <div style={valueContainerStyle}>
                            <CurrentValue
                                value={this.currentValue}
                                unit={this.graphUnit}
                                valueFontSize={72}
                                unitFontSize={72}
                                color={CONSTANTS.COLORS.WHITE}
                            />
                            <ValueDelta
                                value={this.deltaValue}
                                unit={this.graphUnit}
                                marginLeft={-54}
                                fontColor={CONSTANTS.COLORS.WHITE}
                                backgroundColor={CONSTANTS.COLORS.TRANSPARENT}
                            />
                        </div>
                        <div style={pieChartContainerStyle}>
                            <PieChart
                                width={200}
                                height={200}
                            >
                                <Pie
                                    data={this.data}
                                    dataKey="value"
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={80}
                                    outerRadius={100}
                                    label={false}
                                    startAngle={285}
                                    endAngle={60}
                                >
                                    {this.data.map((entry, index) => {
                                        return (
                                            <Cell
                                                key={index}
                                                fill={COLORS[index % COLORS.length]}
                                                stroke={'transparent'}
                                            />
                                        );
                                    })}
                                </Pie>
                            </PieChart>
                            <div style={waterIconContainerStyle}>
                                <WaterIcon color={CONSTANTS.COLORS.WHITE} height={50} width={50} />
                            </div>
                        </div>
                    </div>
                    <PanelFooter>
                        {this.renderFullSummaryLink(linkContainerStyle, linkStyle)}
                    </PanelFooter>
                </div>
            </Panel>
        );
    }
}

const panelStyle: React.CSSProperties = { 
    backgroundColor: CONSTANTS.COLORS.THEME_BLUE, 
    color: CONSTANTS.COLORS.WHITE 
};
const panelContentStyle: React.CSSProperties = { 
    display: CONSTANTS.DISPLAY.FLEX, 
    flexDirection: CONSTANTS.FLEX_DIRECTION.ROW
};
const valueContainerStyle: React.CSSProperties = { 
    display: CONSTANTS.DISPLAY.FLEX, 
    flexDirection: CONSTANTS.FLEX_DIRECTION.COLUMN, 
    flexGrow: CONSTANTS.FLEX_GROW.ONE, 
    justifyContent: CONSTANTS.FLEX_JUSTIFY.CENTER, 
    alignItems: CONSTANTS.ALIGN_ITEMS.CENTER, 
    paddingBottom: 30 
};
const pieChartContainerStyle: React.CSSProperties = { 
    width: 225, 
    height: 225, 
    position: CONSTANTS.POSITION.RELATIVE 
};
const waterIconContainerStyle: React.CSSProperties = { 
    position: CONSTANTS.POSITION.ABSOLUTE, 
    top: '31%', 
    left: '32%'
};
const linkContainerStyle: React.CSSProperties = {
    display: CONSTANTS.DISPLAY.FLEX,
    flexGrow: CONSTANTS.FLEX_GROW.ONE,
    justifyContent: CONSTANTS.FLEX_JUSTIFY.CENTER,
    alignItems: CONSTANTS.ALIGN_ITEMS.END, 
    fontSize: 18, 
    height: 35, 
    borderTop: '2px solid ' + CONSTANTS.COLORS.WHITE, 
    marginLeft: -30, 
    marginRight: -20, 
    position: CONSTANTS.POSITION.RELATIVE
};
const linkStyle: React.CSSProperties = { 
    textDecoration: 'none', 
    color: CONSTANTS.COLORS.WHITE, 
    backgroundColor: CONSTANTS.COLORS.THEME_BLUE, 
    border: '2px solid ' + CONSTANTS.COLORS.WHITE, 
    padding: '15px 35px', 
    borderRadius: 30, 
    position: 'absolute', 
    top: -28 
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/dashboardPanels/TotalBodyWater.tsx